module.exports = __webpack_public_path__ + "img/diablo-iii.d5a4d265.svg";